import { getListColor } from "@/lib/listColors";

export type ListFilterPillArea = {
  id: number;
  name: string;
  color?: string | null;
  bgColor?: string | null;
};

export default function ListFilterPills({
  lists,
  loading,
  selectedListIds,
  onSelect,
  purpose = "planning",
}: {
  lists: ListFilterPillArea[];
  loading: boolean;
  selectedListIds: number[];
  onSelect: (listId: number) => void;
  purpose?: string;
}) {
  return (
    <div className="flex flex-wrap gap-2" aria-label={`${purpose} list filters`}>
      {loading ? (
        <>
          <span className="h-8 w-20 rounded-full bg-muted/50 animate-pulse" />
          <span className="h-8 w-24 rounded-full bg-muted/50 animate-pulse" />
        </>
      ) : lists.length === 0 ? (
        <p className="text-xs text-muted-foreground">No lists yet.</p>
      ) : (
        lists.map(list => {
          const color = getListColor(list.color);
          const selected = selectedListIds.includes(list.id);
          return (
            <button
              key={list.id}
              type="button"
              onClick={() => onSelect(list.id)}
              className={`inline-flex h-8 max-w-full items-center gap-2 rounded-full border px-3 text-xs font-medium transition-all ${
                selected
                  ? "border-foreground/40 bg-accent shadow-sm"
                  : "border-border/60 bg-card hover:border-foreground/30 hover:bg-accent/30"
              }`}
              style={{ color: color.ink, borderColor: selected ? color.base : undefined }}
              aria-pressed={selected}
              aria-label={selected ? `Remove ${list.name} ${purpose} filter` : `Filter ${purpose} by ${list.name}`}
              title={selected ? `Remove ${list.name} filter` : `Show ${list.name} ${purpose} items`}
            >
              <span className="h-2.5 w-2.5 shrink-0 rounded-full" style={{ backgroundColor: color.base }} />
              <span className="truncate">{list.name}</span>
            </button>
          );
        })
      )}
    </div>
  );
}

export { ListFilterPills };
